import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { TenantAppStateQuery, TenantAppStateQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root' })
@QueryHandlerFor(TenantAppStateQuery)
@Wrapper(TenantAppStateQueryHandlerBase)
export class TenantAppStateQueryHandler {
	public constructor(
		http: Http
	) { }
}
